export default __webpack_public_path__ + "static/media/South32_logo.995a9b5c.svg";